var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#F4F6F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#F4F6F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.337 18.5H15.25C14.8358 18.5 14.5 18.8358 14.5 19.25C14.5 19.6642 14.8358 20 15.25 20H24.337C24.6755 21.4334 25.9632 22.5 27.5 22.5C29.0368 22.5 30.3245 21.4334 30.663 20H32.75C33.1642 20 33.5 19.6642 33.5 19.25C33.5 18.8358 33.1642 18.5 32.75 18.5H30.663C30.3245 17.0667 29.0368 16 27.5 16C25.9632 16 24.6755 17.0667 24.337 18.5ZM25.75 19.25C25.75 18.2835 26.5335 17.5 27.5 17.5C28.4665 17.5 29.25 18.2835 29.25 19.25C29.25 20.2165 28.4665 21 27.5 21C26.5335 21 25.75 20.2165 25.75 19.25Z",
    fill: "#003755"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.254 28C14.8398 28 14.504 28.3358 14.504 28.75C14.504 29.1642 14.8398 29.5 15.254 29.5H17.337C17.6755 30.9334 18.9632 32 20.5 32C22.0368 32 23.3245 30.9334 23.663 29.5H32.75C33.1642 29.5 33.5 29.1642 33.5 28.75C33.5 28.3358 33.1642 28 32.75 28H23.663C23.3245 26.5666 22.0368 25.5 20.5 25.5C18.9632 25.5 17.6755 26.5666 17.337 28H15.254ZM20.5 30.5C19.5356 30.5 18.7533 29.7198 18.75 28.7562L18.75 28.75L18.75 28.7438C18.7533 27.7802 19.5356 27 20.5 27C21.4665 27 22.25 27.7835 22.25 28.75C22.25 29.7165 21.4665 30.5 20.5 30.5Z",
    fill: "#003755"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.be7128e4510ddacf4d5d03fadd7c03df.svg";
export { ForwardRef as ReactComponent };